//blog banner slide
const banner = new Swiper('.banner-slider', {
    loop: true,
    navigation: {
        nextEl: '.mobi_slider_btn .swiper-button-next',
        prevEl: '.mobi_slider_btn .swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
});

//article meta image
const article_image = new Swiper('.meta_img', {
    loop: false,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    slidesPerView: 1,
    spaceBetween: 0,
});

// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

// PDP FAQ Tab Button Slider
var swiper = new Swiper(".faq_tab_btn_slider", {
  slidesPerView: "auto",
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });
}
function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach(b => {
    if(b.getAttribute('data-hendles') == tabs_data){
         b.classList.add("active");
        document.querySelector(b.getAttribute('data-hendles')).classList.remove("hidden");
        // document.querySelector(b.getAttribute('data-hendles')).classList.add("active");
    }else{
       b.classList.remove("active");
      if (document.querySelector(b.getAttribute('data-hendles'))) {
         document.querySelector(b.getAttribute('data-hendles')).classList.add("hidden");
         // document.querySelector(b.getAttribute('data-hendles')).classList.remove("active");
      }                                 
    }
  });
}
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end

//blog slider
const blog_swiper = new Swiper(".custom-main-blogs-section", {
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: '.desk_slider_btn .swiper-button-next',
    prevEl: '.desk_slider_btn .swiper-button-prev'
  },
   keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 10 },
    380: { slidesPerView: 1, spaceBetween: 10 },
    768: { slidesPerView: 3, spaceBetween: 30 },
    990: { slidesPerView: 3, spaceBetween: 30 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
  },
});

//contact slider

const contact_swiper = new Swiper(".cust_cont", {
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: '.mulicomn_btn .swiper-button-next',
    prevEl: '.mulicomn_btn .swiper-button-prev'
  },
   keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    0: { slidesPerView: 1, spaceBetween: 10 },
    380: { slidesPerView: 1, spaceBetween: 10 },
    750: { slidesPerView: 2, spaceBetween: 20 },
    990: { slidesPerView: 3, spaceBetween: 20 },
    1200: { slidesPerView: 3, spaceBetween: 30 },
  },
});

//Testimonial slider
var testimonialswiper = new Swiper(".testimonial_img", {
  pagination:{
      el:".swiper-pagination",
      clickable:true
  },
  // autoplay: {
  //     delay: 5000,
  //     disableOnInteraction: false,
  //   },
});

if (window.innerWidth < 750) {
    const trustbadge = new Swiper('.text_trust_slider', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true,
    });
}


// accordions js start
function nav_taggol() {
  const accordionss = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    tab_content.style.maxHeight = tab_content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(tab_content){
      tab_content.style.maxHeight = null;
    }
  };

  accordionss.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const tab_content = accordion.querySelector("[js-acc-single-content]");
    if(intro && tab_content){
        intro.onclick = (e) => {
          if (tab_content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordionss.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });
}
nav_taggol();

//blog sorting
document.addEventListener('DOMContentLoaded', function() {
    var sortingDropdown = document.getElementById("sorting-dropdown");
    if (sortingDropdown) {  
      sortingDropdown.addEventListener("change", function() {
            var selectedOption = this.value;
            sortBlogPosts(selectedOption);
        });
    }
});

function sortBlogPosts(option) {
    var postsContainer = document.querySelector(".blog-articles");
    if (!postsContainer) return; 

    var posts = Array.from(postsContainer.getElementsByClassName("cust_sort_blog"));
    switch (option) {
        case "title-ascending":
            posts.sort(function(a, b) {
                return a.querySelector(".blog-post-title").textContent.localeCompare(b.querySelector(".blog-post-title").textContent);
            });
            break;
        case "title-descending":
            posts.sort(function(a, b) {
                return b.querySelector(".blog-post-title").textContent.localeCompare(a.querySelector(".blog-post-title").textContent);
            });
            break;
        case "created-ascending":
            posts.sort(function(a, b) {
                var dateA = new Date(a.querySelector(".blog-post-date").textContent);
                var dateB = new Date(b.querySelector(".blog-post-date").textContent);
                return dateA - dateB;
            });
            break;
        case "created-descending":
            posts.sort(function(a, b) {
                var dateA = new Date(a.querySelector(".blog-post-date").textContent);
                var dateB = new Date(b.querySelector(".blog-post-date").textContent);
                return dateB - dateA;
            });
            break;
        default:
            break;
    }
    postsContainer.innerHTML = "";
    posts.forEach(function(post) {
        postsContainer.appendChild(post);
    });
}

//language switcher
// document.addEventListener("DOMContentLoaded", function () {
//   const forms = document.querySelectorAll(".pxFormGenerator");
//   function toggleFormsByLanguage(activeLang) {
//     let formFound = false;
//     forms.forEach((form) => {
//       const formLang = form.getAttribute("data-gt-lang");
//       if (formLang === activeLang) {
//         form.style.display = "block";
//         formFound = true;
//       } else {
//         form.style.display = "none";
//       }
//     });
//     if (!formFound) {
//       forms.forEach((form) => {
//         form.style.display = "none";
//       });
//     }
//   }
//   function getActiveLanguage() {
//     const lang = document.documentElement.lang || "de";
//     return lang;
//   }
//   const observer = new MutationObserver(() => {
//     const activeLang = getActiveLanguage();
//     toggleFormsByLanguage(activeLang);
//   });
//   observer.observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
//   const gTranslateDropdown = document.querySelector(".header-geo-language");
//   if (gTranslateDropdown) {
//     gTranslateDropdown.addEventListener("change", () => {
//       const activeLang = getActiveLanguage();
//       toggleFormsByLanguage(activeLang);
//     });
//   }
//   const initialLang = getActiveLanguage();
//   toggleFormsByLanguage(initialLang);
// });

//PDP description load more
document.addEventListener("DOMContentLoaded", function() {
  var showBtn = document.querySelector('.show_btn_des');
  var hideBtn = document.querySelector('.hide_btn_des');
  var fullDescription = document.querySelector('.des_txt_full');
  var shortDescription = document.querySelector('.des_txt_short');

  if (showBtn && hideBtn) {
    showBtn.addEventListener('click', function() {
      fullDescription.style.display = 'block';
      shortDescription.style.display = 'none';
      showBtn.style.display = 'none';
      hideBtn.style.display = 'inline-block';
    });

    hideBtn.addEventListener('click', function() {
      fullDescription.style.display = 'none';
      shortDescription.style.display = 'block';
      showBtn.style.display = 'inline-block';
      hideBtn.style.display = 'none';
    });
  }
});


//PDP Detail load more
document.addEventListener('DOMContentLoaded', function() {
  var showBtnSpec = document.querySelector('.show_btn_spec') || null;    
  var hideBtnSpec = document.querySelector('.hide_btn_spec') || null;
  var maindivs = document.querySelectorAll('.spec_txt') || null;
  var allRows = document.querySelectorAll('.block-row') || null;
  var initiallyVisibleRows = 50; 

  if (document.querySelectorAll('.block-row').length < 3){
    if(showBtnSpec && hideBtnSpec && maindivs){
    showBtnSpec.style.display = 'none';
    hideBtnSpec.style.display = 'none';
     maindivs.forEach(function (maindiv) {
        maindiv.classList.add('load_more_spec'); 
      });
    }
  }

  if (showBtnSpec && hideBtnSpec) {
    showBtnSpec.addEventListener('click', function() {
      var hiddenRows = document.querySelectorAll('.block-row.hidden');

      hiddenRows.forEach(function(row, index) {
        if (index < initiallyVisibleRows) {
          row.classList.remove('hidden');
        }
      });
       maindivs.forEach(function (maindiv) {
        maindiv.classList.add('load_more_spec'); 
      });

      if (document.querySelectorAll('.block-row.hidden').length === 0) {
        showBtnSpec.style.display = 'none';
        hideBtnSpec.style.display = 'inline-block';
      }
    });

    hideBtnSpec.addEventListener('click', function(e) {
      var is_count = 0
       var is_count_selected = null;
      allRows.forEach(function(row, index) {
        console.log(!row.closest('.block-row').classList.contains('hidden'))
        if(!row.closest('.block-rows-wrapper').classList.contains('hidden')){
         var data_main =row.closest('.block-rows-wrapper');
           var allRows_main = data_main.querySelectorAll('.block-row');
          if(allRows_main.length > 10){
            is_count = 10
          }else{
            is_count = parseInt(allRows_main.length / 2);
          }
          allRows_main.forEach(function(row_test, index) {
             if (index > is_count && index <= initiallyVisibleRows) {
              row_test.classList.add('hidden');
            }
          });
          maindivs.forEach(function (maindiv) {
            maindiv.classList.remove('load_more_spec'); 
          });
          showBtnSpec.style.display = 'inline-block';
            hideBtnSpec.style.display = 'none';
            return
        }      
      });  
    });
  }
});

//blog custom search
document.addEventListener('DOMContentLoaded', function() {
  var searchInput = document.getElementById("search-input");
  if (searchInput) {  
      searchInput.addEventListener("input", function() {
          var query = this.value.toLowerCase();  
          var postsContainer = document.querySelector(".blog-articles");
          var posts = Array.from(postsContainer.getElementsByClassName("cust_sort_blog")); 

          posts.forEach(function(post) {
              var title = post.querySelector(".blog-post-title").textContent.toLowerCase(); 
              if (title.includes(query)) {
                  post.style.display = "block";  
              } else {
                  post.style.display = "none";
              }
          });
      });
  }
});

// Contact US Form Custom Select Dropdown JS Start
var x, i, j, l, ll, selElmnt, a, b, c;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.addEventListener("click", function(e) {
        /*when an item is clicked, update the original select box,
        and the selected item:*/
        var y, i, k, s, h, sl, yl;
        s = this.parentNode.parentNode.getElementsByTagName("select")[0];
        sl = s.length;
        h = this.parentNode.previousSibling;
        for (i = 0; i < sl; i++) {
          if (s.options[i].innerHTML == this.innerHTML) {
            s.selectedIndex = i;
            h.innerHTML = this.innerHTML;
            y = this.parentNode.getElementsByClassName("same-as-selected");
            yl = y.length;
            for (k = 0; k < yl; k++) {
              y[k].removeAttribute("class");
            }
            this.setAttribute("class", "same-as-selected");
            break;
          }
        }
        h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function(e) {
      /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
      e.stopPropagation();
      closeAllSelect(this);
      this.nextSibling.classList.toggle("select-hide");
      this.classList.toggle("select-arrow-active");
    });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x, y, i, xl, yl, arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i)
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", closeAllSelect);

// Contact US Form Custom Select Dropdown JS End



//About page div scroll add remove class
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.custom-content-blocks .cst--col-blocks');
  const scrollElems = document.querySelectorAll('.custom-content-blocks .col-blocks');
  
  function handleScroll() {
    const windowHeight = window.innerHeight;
    
    sections.forEach((section) => {
      const sectionPosition = section.getBoundingClientRect();
      if (sectionPosition.top < windowHeight && sectionPosition.bottom >= 0) {
        section.classList.add('in-view');
      } else {
        section.classList.remove('in-view');
      }
    });
  }

  scrollElems.forEach((scrollElem) => {
    scrollElem.addEventListener('scroll', handleScroll);  
  });
  
  handleScroll();
});


let items = document
.querySelector(".header__inline-menu")
.querySelectorAll("details");

items.forEach(item => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
  item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
  });
    item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
    });
  });
});

(function() {


    const comper_btn = document.querySelectorAll("[href='#data-camperpopup']") || null;  
   comper_btn.forEach((comperclick) => {
    comperclick.onclick = (e) => {
      e.preventDefault();
          if(document.querySelector('.coder-comparable-button')){
              document.querySelector('.coder-comparable-button').click();
          } else{
        alert(' Für den Produktvergleich müssen mindestens zwei Produkte hinzugefügt werden');
      }
        };
  });
  
  
const header_operlay = document.querySelector(".header_transparent");
  if(header_operlay){
    document.body.classList.add('header-overlay');
  }  
})();

// document.addEventListener("DOMContentLoaded", function() {
//     const targetElement = document.getElementById('shopify-section-template--22599586545998__custom_image_with_text_EqJ9Uh');
//     if (targetElement) {
//         const targetPosition = targetElement.getBoundingClientRect().top - 1000;
//       console.log("targetPosition",targetPosition)
//         window.scrollBy({
//         top: 7000,  
//         behavior: 'smooth' 
//       });
//     }   
// });

//blog page land click JS

const buttons = document.querySelectorAll("[data-custom-blog-filter]");
if (buttons) {
  buttons.forEach((button) => {
      button.addEventListener("click", (event) => {
         const ul = button.nextElementSibling;
    const allDropdowns = document.querySelectorAll(".custom_datablog_filter_list");
        if(!ul.hidden){
             allDropdowns.forEach((dropdown) => {
              if (!dropdown.hidden) {
                  dropdown.setAttribute("hidden", "");
              }
          });
        }else{
          allDropdowns.forEach((dropdown) => {
              if (!dropdown.hidden) {
                  dropdown.setAttribute("hidden", "");
              }
          });
          if (ul && ul.classList.contains("custom_datablog_filter_list")) {
              ul.toggleAttribute("hidden");
          }
        }
      });
  });
}

//checkout popup
 document.addEventListener("DOMContentLoaded", function () {
  const tooltips = document.querySelectorAll("[data-popup-open]");
  const popups = document.querySelectorAll("[data-popup]");
  const closeButtons = document.querySelectorAll("[data-popup-close]");
  const submitButton = document.querySelector(".cst-contact-form-btn");

  tooltips.forEach((tooltip) => {
    tooltip.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = tooltip.getAttribute("data-popup-target");
      const popup = document.getElementById(targetId);
      if (popup) {
        popup.classList.add("active");
        document.documentElement.classList.add("popup-active");
      }
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      popups.forEach((popup) => popup.classList.remove("active"));
      document.documentElement.classList.remove("popup-active");
    });
  });

  popups.forEach((popup) => {
    popup.addEventListener("click", (e) => {
      if (e.target === popup) {
        popup.classList.remove("active");
        document.documentElement.classList.remove("popup-active");
      }
    });
  });

  if (submitButton && document.body.classList.contains('template- index')) {
    submitButton.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent default form submission
      console.log("submitButton",submitButton);
      consoel.log("popup",popups);
      popups.forEach((popup) => popup.classList.remove("active")); // Close the popup
      document.documentElement.classList.remove("popup-active");
      window.location.href = "/"; // Redirect to the homepage
    });
  }
});

   // const popup_open = document.querySelector('.cst-contact-form-btn') || null;
   //  if(popup_open){
   //    console.log("popup_open",popup_open);
   //      popup_open.addEventListener("click", (event) => {
   //        console.log("popup_open",popup_open)
   //              setTimeout(() => {
   //            const popup_open = document.querySelector('[popup_show]') || null;
   //              popup_open.classList.add("open"); 
   //              document.body.classList.add("popup_open");
   //              },500);
   //        });
   //  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
        
           const main_popup = event.target.closest('[data-poup]') || null;

          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 


